<template>
    <yuukyuukanri-detail />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import YuukyuukanriDetail from '@/components/yuukyuukanri/Detail.vue'

export default defineComponent({
    setup() {
      return {}
    },
    components: {
      'yuukyuukanri-detail': YuukyuukanriDetail
    }
})
</script>
